import React, { useCallback, useEffect, useState } from "react";
import StarRating from "../components/ratingStar";
import "../styles/textRecommandationStyle.css";
import { useApi } from "../../../../service/ApiContext";
import assesClient from "../data/api/AssesNameClient";
import { LocalStorage } from "../../../../utils/Utils";
import CommonUtils from "../../../../utils/Common_Utils";
import Loader from "../../../../utils/Utils";

import AssessmentResponse, {
  AssessmentDetails,
} from "../data/response/AssesResponse";
import { Select, MenuItem, FormControl } from "@mui/material";
import { SelectChangeEvent } from "@mui/material";
import { ScoreResponse } from "../data/response/scoreResponse";
import {
  Recommendation,
  RecommendationResponse,
} from "../data/response/recommandationResponse";
import skill from "../../../../assets/images/recommandation/skillEmpty.svg"; // Placeholder Image
import { Container } from "reactstrap";
import SkillImage from "../components/skillImage";
import customArrow from "../../../../assets/images/recommandation/chevron-down.png";
import { useAlert } from "../../../../components/AlertContextComponent";
import strings from "../../../../utils/Strings";
// Define a type for the dimensions coming from the recommendation API
interface TabDimensions {
  id: number;
  title: string;
  content: string[];
  rating: number;
  note: string[];
  width: string;
  height: string;
}

const TextRecommendation: React.FC = () => {
  const [assessments, setAssessments] = useState<AssessmentDetails[]>([]);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState<string>("");
  const [candidateId, setCandidateId] = useState<string>("");
  const [tabDimensions, setTabDimensions] = useState<TabDimensions[]>([]); // State for storing tab dimensions
  const [activeTab, setActiveTab] = useState<number>(0); // Track the active tab
  const [isSkillReportEmpty, setIsSkillReportEmpty] = useState<boolean>(true); // Track if skill report is empty
  const [dropdownOpen, setDropdownOpen] = useState(false); // State to control dropdown open/close
  const [showSkillImage, setShowSkillImage] = useState(false);
  const { showAlert } = useAlert();
  const [isAssessmentsLoading, setIsAssessmentsLoading] = useState(true);

  const api = useApi();

  // Fetch assessments for the candidate
  const fetchAssessments = useCallback(async () => {
    setIsAssessmentsLoading(true);
    Loader.showLoading(strings.loading);

    const param = { offset_time: CommonUtils.formatLocalTime() };

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<AssessmentResponse>(
        assesClient.assesUrl,
        param,
      );

      if (response.data && Array.isArray(response.data.assessment_names)) {
        setAssessments(response.data.assessment_names);
        if (response.data.assessment_names.length > 0) {
          const firstAssessment = response.data.assessment_names[0];
          setSelectedAssessmentId(firstAssessment.assessment_id);
          setCandidateId(firstAssessment.candidate_id);
          fetchTabs(
            firstAssessment.candidate_id,
            firstAssessment.assessment_id,
          );
        } else {
          setSelectedAssessmentId("");
          setCandidateId("");
        }
      } else {
        setAssessments([]);
        setSelectedAssessmentId("");
        setCandidateId("");
      }
    } catch (error) {
      setAssessments([]);
    } finally {
      setIsAssessmentsLoading(false);
      setTimeout(() => {
        Loader.dismissLoading();
      }, 1000);
    }
  }, [api]);
  const [isSkillReportLoading, setIsSkillReportLoading] = useState(true);

  // Fetch skill report based on candidateId and assessmentId
  const fetchTabs = async (candidateId: string, assessmentId: string) => {
    setIsSkillReportLoading(true);
    Loader.showLoading(strings.loading);

    const param = { candidate_id: candidateId, assessment_id: assessmentId };
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<ScoreResponse>(assesClient.scores, param);
      if (
        response.data &&
        response.data.skill_report &&
        response.data.skill_report.length > 0
      ) {
        setIsSkillReportEmpty(false); // Skill report is not empty
        recommendation(assessmentId);
      } else {
        setIsSkillReportEmpty(true); // Skill report is empty
      }
    } catch (error) {
    } finally {
      setIsSkillReportLoading(false); // <-- NEW
      setTimeout(() => {
        Loader.dismissLoading();
      }, 2000);
    }
  };

  const handleArrowClick = () => {
    setDropdownOpen((prevState) => !prevState); // Toggle dropdown open/close
  };

  // Fetch recommendation with tab dimensions
  const recommendation = async (assessmentId: string) => {
    Loader.showLoading(strings.loading);

    const param = { assessment_id: assessmentId };
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<RecommendationResponse>(
        assesClient.recommendation,
        param,
      );
      if (response.data.detail === null) {
        showAlert({
          show: true,
          title: "Error",
          message: "No recommendations available.",
          button1Text: "Cancel",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {
            ("");
          },
        });
        setTabDimensions([]);
        return;
      } else if (response.data && response.data.recommendations) {
        const tabData = response.data.recommendations.map((rec, index) => ({
          id: index,
          title: rec.dimension,
          content: rec.recommendation,
          rating: rec.rating,
          note: rec.note,
          width: "auto",
          height: "auto",
        }));
        setTabDimensions(tabData);
      }
    } catch (error) {
    } finally {
      Loader.dismissLoading();
    }
  };

  useEffect(() => {
    fetchAssessments();
  }, []);

  const handleDropdownChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    setSelectedAssessmentId(selectedId);

    const selectedAssessment = assessments.find(
      (assessment) => assessment.assessment_id === selectedId,
    );
    if (selectedAssessment) {
      setCandidateId(selectedAssessment.candidate_id);
      fetchTabs(selectedAssessment.candidate_id, selectedId);
    }
  };

  const getTrimmedAssessmentName = (name: string): string => {
    // Regular expression to match everything after the last occurrence of " - " followed by a date (YYYY/MM/DD)
    const regex = / - \d{4}\/\d{2}\/\d{2}$/;

    // Replace the date part (if it matches the format) with an empty string
    return name.replace(regex, "").trim();
  };
  return (
     <div>
      <div className="desktop-ui_assessmentCheck">
    <div className="ex-example-page">
      {/* Render SkillImage when no assessments */}
      {isAssessmentsLoading ? (
        <></> // Or a loader if you want
      ) : assessments.length === 0 ? (
        <SkillImage />
      ) : isSkillReportLoading ? (
        <></>
      ) : isSkillReportEmpty ? (
        // Render SkillImage with Dropdown when the skill report is empty
        <div style={{ textAlign: "center", padding: "20px" }}>
          {assessments.length > 0 && (
            <div className="s-drop-container">
              <FormControl fullWidth className="custom-select">
                <Select
                  labelId="assessment-select-label"
                  value={selectedAssessmentId}
                  onChange={handleDropdownChange}
                  open={dropdownOpen} // Control dropdown open/close using the state
                  onClose={() => setDropdownOpen(false)} // Close dropdown when clicking outside
                  onOpen={() => setDropdownOpen(true)} // Open dropdown when triggered
                  displayEmpty
                  sx={{
                    appearance: "none",
                    backgroundSize: "15px 15px",
                    paddingRight: "30px",
                    "& .MuiSelect-icon": {
                      display: "none", // Hide the default arrow
                    },
                  }}
                  inputProps={{
                    style: {
                      appearance: "none", // Hides default arrow
                      paddingRight: "30px", // Space for custom arrow
                    },
                  }}
                  MenuProps={{ PaperProps: { className: "custom-menu" } }}
                >
                  {assessments.map((assessment) => (
                    <MenuItem
                      key={assessment.assessment_id}
                      value={assessment.assessment_id}
                    >
                      <div className="assessment-content">
                        <span className="assessment-name">
                          {getTrimmedAssessmentName(assessment.assessment_name)}
                        </span>
                        <span className="divider"> | </span>
                        <span className="assessment-timestamp">
                          {assessment.timestamp}
                        </span>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
                <div className="custom-arrow" onClick={handleArrowClick}></div>
              </FormControl>
            </div>
          )}
          <SkillImage />
        </div>
      ) : tabDimensions.length === 0 ? (
        // Render Popup when recommendationDetail is null
        <></>
      ) : (
        // Render full content when all data is present
        <div style={{ display: "flex", height: "100vh" }}>
          {/* Left Menu */}
          <div className="ex-left-menu">
            {tabDimensions.map((tab) => (
              <div
                key={tab.id}
                className={`ex-menu-item ${
                  activeTab === tab.id ? "ex-selected" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
                style={{ cursor: "pointer" }}
              >
                {tab.title}
              </div>
            ))}
          </div>
          {/* Right Section */}
          <div className="ex-right-section">
            <div className="ex-right-sectionContainer">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="starHeader">
                  <h2 className="ex-perform">Performance</h2>
                  <StarRating
                    rating={
                      activeTab !== null
                        ? tabDimensions.find((tab) => tab.id === activeTab)
                            ?.rating || 0
                        : 0
                    }
                  />
                </div>
                {/* MUI Dropdown */}
                <div className="ex-drop-container">
                  <FormControl fullWidth className="custom-select">
                    <Select
                      labelId="assessment-select-label"
                      value={selectedAssessmentId}
                      onChange={handleDropdownChange}
                      displayEmpty
                      open={dropdownOpen} // Control dropdown open/close using the state
                      onClose={() => setDropdownOpen(false)} // Close dropdown when clicking outside
                      onOpen={() => setDropdownOpen(true)} // Open dropdown when triggered
                      sx={{
                        appearance: "none",
                        backgroundSize: "15px 15px",
                        paddingRight: "30px",
                        "& .MuiSelect-icon": {
                          display: "none", // Hide the default arrow
                        },
                      }}
                      MenuProps={{ PaperProps: { className: "custom-menu" } }}
                    >
                      {assessments.map((assessment) => (
                        <MenuItem
                          key={assessment.assessment_id}
                          value={assessment.assessment_id}
                        >
                          <div className="assessment-content">
                            <span className="assessment-name">
                              {getTrimmedAssessmentName(
                                assessment.assessment_name,
                              )}
                            </span>
                            <span className="divider"> | </span>
                            <span className="assessment-timestamp">
                              {assessment.timestamp}
                            </span>
                          </div>
                        </MenuItem>
                      ))}
                    </Select>
                    <div
                      className="custom-arrow"
                      onClick={handleArrowClick}
                    ></div>
                  </FormControl>
                </div>
              </div>
              {/* Recommendations List */}
              <p className="jText">
                Jozuna recommends you to do the following:
              </p>
              <ul className="ex-sug-list">
                {activeTab !== null &&
                  tabDimensions
                    .find((tab) => tab.id === activeTab)
                    ?.content.map((item, index) => (
                      <li key={index} className="ex-sug-item">
                        <span className="ex-tick-icon"></span>
                        {item}
                      </li>
                    ))}
              </ul>
              {/* Additional Note */}
              <div className="ex-additional-note">
                {activeTab !== null &&
                  tabDimensions
                    .find((tab) => tab.id === activeTab)
                    ?.note.map((noteItem, index) => (
                      <p key={index} style={{ margin: 0 }}>
                        {noteItem}
                      </p>
                    ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
              <div className="mobile-ui_assessmentCheck"><p>The Recommendation is not accessible on mobile devices.</p> </div>

    </div>
  );
};

export default TextRecommendation;
